import { Component, OnInit, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { VolunteerRegistration } from "../../models/volunteer.model";

@Component({
  selector: "app-shift-dialog",
  templateUrl: "./shift-dialog.component.html",
})
export class ShiftDialogComponent implements OnInit {
  isSubmitting: boolean;
  volunteerRegistration: VolunteerRegistration;

  constructor(
    public dialogRef: MatDialogRef<ShiftDialogComponent>,

    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  onNoClick(): void {
    this.dialogRef.close();
  }

  ngOnInit() { }
  }

